import React from 'react'

const Container = ({children, addClass}) => {
  return <div className={"container mx-auto px-4 py-10 " + addClass}>{children}</div>
}

export default Container
